<section class="users-page">
  <div class="d-flex align-items-center justify-content-between mb-3">
    <div>
      <h3 class="title mb-1">Achievements</h3>
      <p class="subtitle page-desc mb-0">Add and manage in-app achievements for users.</p>
    </div>
  </div>

  <div class="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-3">
    <div class="d-flex align-items-center gap-2">
      <app-search-box tooltipText="Search By name and description" [value]="searchTerm()"
      (search)="onSearch($event)"></app-search-box>
      @if (hasSelection()) {
        <button class="btn btn-icon btn-delete-bulk" (click)="deleteSelectedAchievements()"
          title="Delete Selected">
          <i class="pi pi-trash" style="font-size: 1.25rem;"></i>
        </button>
      }
    </div>

    <div class="d-flex align-items-center gap-3 ms-auto">
      <button class="btn btn-primary" (click)="openAddModal()">
        <i class="fa-solid fa-plus me-2"></i> Add Achievement
      </button>
      <div class="d-flex align-items-center gap-2 border rounded px-1 header-icon-actions-wrapper">
        <button type="button" class="btn btn-icon p-1 header-icon-action-btn" (click)="fetchAchievements()"
          title="Refresh">
          <i class="pi pi-refresh" style="font-size: 1.25rem; color: #6b7280;"></i>
        </button>
        <button type="button" class="btn btn-icon p-1 tooltip-wrap header-icon-action-btn"
          (click)="toggleIncludeDeleted()">
          <i class="pi pi-asterisk" style="font-size: 1.25rem;"
          [style.color]="includeDeleted() ? '#ec4899' : '#6b7280'"></i>
          <span class="tooltip-box">Include Mark Deleted</span>
        </button>
      </div>
    </div>
  </div>

  <div class="table-container shadow">
    <table class="user-table" style="width: 100%; table-layout: fixed;">
      <thead>
        <tr>
          <th class="checkbox-col" width="32">
            <input type="checkbox" [checked]="allSelected()" (change)="onToggleSelectAll()" />
          </th>
          <th class="sortable" style="width: 15%;" (click)="onSort('badge')">
            Badge <span class="sort-indicator" [class.active]="currentSortField() === 'badge'">{{ getSortIcon('badge')
          }}</span>
        </th>
        <th class="sortable" style="width: 15%;" (click)="onSort('name')">
          Name <span class="sort-indicator" [class.active]="currentSortField() === 'name'">{{ getSortIcon('name')
        }}</span>
      </th>
      <th class="sortable" style="width: 30%;" (click)="onSort('description')">
        Description <span class="sort-indicator" [class.active]="currentSortField() === 'description'">{{
      getSortIcon('description') }}</span>
    </th>
    <th class="sortable" style="width: 15%;" (click)="onSort('category')">
      Category <span class="sort-indicator" [class.active]="currentSortField() === 'category'">{{
    getSortIcon('category') }}</span>
  </th>
  <th class="sortable" style="width: 10%;" (click)="onSort('target')">
    Target <span class="sort-indicator" [class.active]="currentSortField() === 'target'">{{
  getSortIcon('target') }}</span>
</th>
<th class="text-center">Action</th>
</tr>
</thead>
<tbody>
  @if (loading()) {
    <tr>
      <td colspan="7">
        <div class="d-flex justify-content-center py-4">
          <app-spinner-loader [width]="35" />
        </div>
      </td>
    </tr>
  } @else if (achievements().length === 0) {
    <tr>
      <td colspan="7" class="no-data-cell">No achievements found</td>
    </tr>
  } @else {
    @for (a of achievements(); track trackById($index, a)) {
      <tr [ngClass]="{'deleted-row': !!a.deletedAt}"
        [class.selected]="isSelected(a)">
        <td class="checkbox-col">
          <input type="checkbox" [checked]="isSelected(a)" (change)="onToggleSelect(a)" />
        </td>
        <td class="text-start">
          <div class="badge-emoji">
            @if (getBadgeType(a.badge) === 'image') {
              <img [src]="a.badge" class="table-img-badge" alt="Badge" />
            } @else if (getBadgeType(a.badge) === 'icon') {
              <i [class]="a.badge + ' table-icon-badge'"></i>
            } @else {
              {{ a.badge }}
            }
          </div>
        </td>
        <td>
          <div class="d-flex align-items-center gap-2">
            <span class="fw-semibold">{{ a.name }}</span>
          </div>
        </td>
        <td>
          <p class="notif-msg" [pTooltip]="a.description || 'N/A'" tooltipPosition="top">
            {{ a.description ? ((a.description | slice:0:30) + (a.description.length > 30 ? '...' : '')) : 'N/A' }}
          </p>
        </td>
        <td class="text-start">
          <span class="badge" [class.badge-swipe]="a.category === 'swipe'"
            [class.badge-match]="a.category === 'match'" [class.badge-reward]="a.category === 'reward'"
            [class.badge-share]="a.category === 'share'">
            {{ a.category | titlecase }}
          </span>
        </td>
        <td class="text-start fw-semibold">{{ a.target }}</td>
        <td class="text-center">
          <div class="action-buttons">
            <button class="btn btn-edit" title="Edit" (click)="openEditModal(a)" [disabled]="!!a.deletedAt">
              Edit
            </button>
          </div>
        </td>
      </tr>
    }
  }
</tbody>
</table>

<div class="pagination-section">
  <div class="pagination-info">
    <span>
      Showing {{ startIndex }} to {{ endIndex }} of
      {{ totalCount() }} Entries
    </span>
  </div>
  <div class="d-flex gap-2">
    @if (achievements().length !== 0) {
      <label class="page-size-label" for="pageSizeSelect">Page Size:</label>
      <select id="pageSizeSelect" [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChange($event)"
        class="form-select">
        @for (size of pageSizes; track size) {
          <option [value]="size">
            {{ size }}
          </option>
        }
      </select>
    }
    <button class="btn btn-outline pagination-btn"
      [disabled]="currentPage() === 1 || loading() || achievements().length === 0" (click)="previousPage()">
      &lt; Prev
    </button>
    <button class="btn btn-outline pagination-btn" [disabled]="currentPage() === totalPages || loading()"
      (click)="nextPage()">
      Next &gt;
    </button>
  </div>
</div>
</div>
</section>

@if (isModalOpen()) {
  <div class="modal-backdrop" (click)="closeModal()"></div>
  <div class="modal-panel">
    <app-achievement-form [achievement]="editingAchievement()" (saved)="onFormSaved()" (cancelled)="closeModal()" />
  </div>
}